var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 10.7266C4.73438 10.7266 5.25 10.2344 5.25 9.60156V1.35156C5.25 0.742188 4.73438 0.226562 4.125 0.226562H1.875C1.24219 0.226562 0.75 0.742188 0.75 1.35156V9.60156C0.75 10.2344 1.24219 10.7266 1.875 10.7266H4.125ZM11.25 9.60156V1.35156C11.25 0.742188 10.7344 0.226562 10.125 0.226562H7.875C7.24219 0.226562 6.75 0.742188 6.75 1.35156V9.60156C6.75 10.2344 7.24219 10.7266 7.875 10.7266H10.125C10.7344 10.7266 11.25 10.2344 11.25 9.60156Z",
    fill: "#EC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.177f7423.svg";
export { ForwardRef as ReactComponent };